'use client';

import { createContext, useContext } from 'react';

export type SiteSettingsContextType = {
    theme: string;
    locale: Intl.LocalesArgument;
    currency: string;
    siteTagId: string;
    imgixUrl?: string;
};

const SiteSettingsContext = createContext<SiteSettingsContextType | null>(null);

export const useSiteSettingsContext = () => {
    const context = useContext(SiteSettingsContext);
    if (!context) {
        throw new Error('useSiteSettingsContext must be used within a SiteSettingsContext');
    }
    return context;
};

export function SiteSettingsProvider({
    children,
    theme,
    locale,
    currency,
    siteTagId,
    imgixUrl,
}: SiteSettingsContextType & {
    children: React.ReactNode;
}) {
    return (
        <SiteSettingsContext.Provider value={{ theme, locale, currency, siteTagId, imgixUrl }}>
            {children}
        </SiteSettingsContext.Provider>
    );
}
